/* eslint-disable arrow-body-style */
import { IUseOptionsProps } from "./_type";
import { useMemo } from "react";
import { useLineSeriesConfig, useYAxisConfig} from './chartPlugHooks';
import { EChartsOption } from "echarts";
import {  COMMON_TEXT_STYLE, COMMON_TOOLTIP, COMMON_VERTICAL_COLOR, COMMON_VERTICAL_LINE_GRID, COMMON_VERTICAL_XAXIS_CONFIG  } from "./constant";

export const useOption = (props: IUseOptionsProps) => {
  const {
    dataSource,
    expandOption,
    tooltip,
    series,
  } = props;
  const yAxisConfig = useYAxisConfig(dataSource);
  const seriesConfig = useLineSeriesConfig({ dataSource, series});

  const option = useMemo(()=>{
    return {
      textStyle: COMMON_TEXT_STYLE,
      color: COMMON_VERTICAL_COLOR,
      title: {
        text: ''
      },
      tooltip: {
        ...COMMON_TOOLTIP,
        ...(tooltip ? tooltip : {}),
      },
      legend: {show: false},
      grid: COMMON_VERTICAL_LINE_GRID,
      xAxis: COMMON_VERTICAL_XAXIS_CONFIG,
      yAxis: yAxisConfig,
      series: seriesConfig
    };
  },[seriesConfig, tooltip,  yAxisConfig]);

  return expandOption ? expandOption(option as EChartsOption ) : option;
};